/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useState as t}from"react";import{useIsoMorphicEffect as e}from"./use-iso-morphic-effect.js";function r(t){var e;if(t.type)return t.type;let r=null!=(e=t.as)?e:"button";return"string"==typeof r&&"button"===r.toLowerCase()?"button":void 0}function o(o,n){let[u,s]=t((()=>r(o)));return e((()=>{s(r(o))}),[o.type,o.as]),e((()=>{u||n.current&&n.current instanceof HTMLButtonElement&&!n.current.hasAttribute("type")&&s("button")}),[u,n]),u}export{o as useResolveButtonType};
//# sourceMappingURL=use-resolve-button-type.js.map
